import React from 'react';
import './css/Login.css';
import AppLoggedIn from './AppLoggedIn';
import AppLogin from './AppLogin';
import { uuidv4, getBrowser } from './utils/ApiUtils';

let basicInfo = null, uniqueId = 0, isMobile = false;

export default class App extends React.Component {
  
    constructor(props) {
        super(props);
        this.state = { landingValue: 0 };
        isMobile = window.innerWidth<768;
    }
    componentDidMount() {
        console.log = () => {};
        this.fetchBasicInfo();
    }
    fetchBasicInfo = async() => {
        console.log('fetch basic info');
        uniqueId = uuidv4();
        let userAgent = window.navigator.userAgent;
        let osPlatform = window.navigator.platform;
        let resolution = window.innerWidth+'X'+window.innerHeight;
        basicInfo = { platform: 'Web', resolution: resolution, uniqueId: uniqueId,
          browser: getBrowser(), 'userAgent': userAgent, appVersion: '0.4', os: osPlatform };
        let currentTime = Date.now();
        let loginTime = localStorage.getItem('loginTime') || '';
        console.log('loginTime='+loginTime+' currentTime='+currentTime+' url params='+JSON.stringify(this.props));
        if(currentTime-loginTime<86400000) {
            this.setState({ landingValue: 1 });
        } else {
            this.setState({ landingValue: 2 });
        }
    }
    goToLanding = (value) => {
        this.setState({ landingValue: value });
    }
    render() {
        let value = this.state.landingValue;
        if(value) {
            return (
                value===1
                ?
                <AppLoggedIn basicInfo={basicInfo} uniqueId={uniqueId} goToLanding={this.goToLanding} isMobile={isMobile} />
                :
                <AppLogin basicInfo={basicInfo} uniqueId={uniqueId} goToLanding={this.goToLanding} isMobile={isMobile} />
            );
        } else {
            return <div/>;
        }
    }

}
